import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  usePageMeta("Page Not Found — Shattara AI", "", { noIndex: true });
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
      {/* Floating illustration */}
      <motion.img
        src="/images/404_image.png"
        alt="Lost in space — page not found"
        className="mb-8 w-full max-w-xs sm:max-w-sm md:max-w-md"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1, y: [0, -12, 0] }}
        transition={{
          opacity: { duration: 0.6 },
          scale: { duration: 0.6 },
          y: { duration: 4, repeat: Infinity, ease: "easeInOut" },
        }}
      />

      {/* Text */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <h1 className="mb-3 text-5xl font-bold tracking-tight text-foreground sm:text-6xl">
          404
        </h1>
        <p className="mb-2 text-xl font-semibold text-foreground sm:text-2xl">
          Oops! This page wandered off
        </p>
        <p className="mb-8 max-w-md text-muted-foreground">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>
      </motion.div>

      {/* CTAs */}
      <motion.div
        className="flex flex-wrap items-center justify-center gap-4"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <Button asChild size="lg">
          <Link to="/">Back to Home</Link>
        </Button>
        <Button asChild variant="outline" size="lg">
          <Link to="/blog">Browse Blog</Link>
        </Button>
      </motion.div>
    </div>
  );
};

export default NotFound;
